import { GlobeAltIcon, CalendarDaysIcon } from '@heroicons/react/24/outline';
import { useData } from '../context/DataContext.js';

export default function PromoterCardView({ promoters }) {
  const { events } = useData();

  // Calculate event counts for each promoter
  const getEventCount = (organiserId) => {
    return events?.filter(event => 
      event.OrganiserID === organiserId 
    ).length || 0;
  };

  // Add color mapping for reach values
  const getReachColor = (reach) => {
    switch (reach) {
      case 'Local':
        return 'bg-green-100 text-green-800';
      case 'National':
        return 'bg-blue-100 text-blue-800';
      case 'Global':
        return 'bg-orange-100 text-orange-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {promoters.map((promoter) => (
          <div
            key={promoter.OrganiserID}
            onClick={() => promoter.WebsiteLink && window.open(promoter.WebsiteLink, '_blank', 'noopener,noreferrer')}
            className="rounded-xl shadow-lg overflow-hidden transform transition duration-200 hover:scale-105 hover:shadow-xl cursor-pointer flex flex-col"
          >
            {/* Image Section */}
            <div className="h-[100px] w-full flex items-center justify-center bg-gradient-to-br from-slate-500 to-slate-800">
              {promoter.organiserImage && (
                <img
                  src={promoter.organiserImage}
                  alt={promoter.BusinessName}
                  className="w-full h-[100px] object-contain p-4"
                />
              )}
            </div>

            {/* Content Section */}
            <div className="flex-1 bg-white h-full flex flex-col">
              <div className="p-5 flex-1 flex flex-col">
                {/* Business Name */}
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {promoter.BusinessName}
                </h3>

                {/* Tags */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {promoter.Reach && (
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getReachColor(promoter.Reach)}`}>
                      {promoter.Reach}
                    </span>
                  )}
                  {promoter.Discipline && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      {promoter.Discipline}
                    </span>
                  )}
                </div>

                {/* Links and Stats - Pushed to bottom */}
                <div className="mt-auto flex flex-col sm:flex-row sm:items-center sm:justify-between text-sm text-gray-500 gap-2 sm:gap-0">
                  <a
                    href={promoter.WebsiteLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className="inline-flex items-center hover:text-gray-700"
                  >
                    <GlobeAltIcon className="h-4 w-4 mr-1" />
                    Website
                  </a>
                  <div className="inline-flex items-center">
                    <CalendarDaysIcon className="h-4 w-4 mr-1" />
                    <span className="font-medium">{getEventCount(promoter.OrganiserID)}</span>
                    <span className="ml-1"> events</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
  